import { useState } from "react";
import clsx from "clsx";

type Props =
  | { value: number; readonly: true; onChange?: never; saving?: never }
  | { value: number; readonly?: false; onChange: (grade: number) => void; saving?: boolean };

function StarRating({ value, onChange, saving, readonly }: Props) {
  const [hovered, setHovered] = useState(0);
  const display = readonly ? value : (hovered || value);

  const starSvg = (
    <svg viewBox="0 0 20 20" fill="currentColor">
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
  );

  if (readonly) {
    return (
      <div className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={clsx("w-5 h-5", display >= star ? "text-amber-400" : "text-slate-200")}
          >
            {starSvg}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div className="flex gap-0.5" onMouseLeave={() => setHovered(0)}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={saving}
          onMouseEnter={() => setHovered(star)}
          onClick={() => onChange(star)}
          className={clsx(
            "w-5 h-5 transition-colors",
            display >= star ? "text-amber-400" : "text-slate-200",
            !saving && "cursor-pointer",
            saving && "opacity-50 cursor-wait"
          )}
        >
          {starSvg}
        </button>
      ))}
    </div>
  );
}

export default StarRating;
